"use client";
import { ServerError } from "@/components/Errors";
import { ThemeProvider } from "@/ThemeProvider";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // useEffect(() => {
  //     // Log the error to an error reporting service
  //     console.log("error in global component")
  //     console.error(error)
  // }, [error])

  return (
    <html>
      <body>
        <ThemeProvider>
          <ServerError onClick={() => reset()} />
        </ThemeProvider>
      </body>
    </html>
  );
}
